// extracted by mini-css-extract-plugin
module.exports = {"root":"FlowEditor_root__3UQTK","configColumn":"FlowEditor_configColumn__2CZHk","promptsColumn":"FlowEditor_promptsColumn__gyjY6","previewColumn":"FlowEditor_previewColumn__2z3t-"};